'use strict';
import * as $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$0024 from "./app.data.-Organization-Name$package$-Organization-Name$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationName$package$OrganizationNameForm$() {
  this.aDq = null;
  this.aDH = null;
  this.aDt = null;
  this.aDu = false;
  this.aDx = null;
  this.aDy = false;
  this.aDF = null;
  this.aDG = false;
  this.aDr = null;
  this.aDs = false;
  this.aDD = null;
  this.aDE = false;
  this.aDz = null;
  this.aDA = false;
  this.aDB = null;
  this.aDC = false;
  this.aDv = null;
  this.aDw = false;
  $n_Lapp_data_OrganizationName$package$OrganizationNameForm$ = this;
  this.aDq = $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$0024.$m_Lapp_data_OrganizationName$package$OrganizationName$();
  this.aDH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$0024.$m_Lapp_data_OrganizationName$package$OrganizationName$());
  new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "Name";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
}
export { $c_Lapp_data_OrganizationName$package$OrganizationNameForm$ as $c_Lapp_data_OrganizationName$package$OrganizationNameForm$ };
$p = $c_Lapp_data_OrganizationName$package$OrganizationNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationName$package$OrganizationNameForm$;
/** @constructor */
function $h_Lapp_data_OrganizationName$package$OrganizationNameForm$() {
}
export { $h_Lapp_data_OrganizationName$package$OrganizationNameForm$ as $h_Lapp_data_OrganizationName$package$OrganizationNameForm$ };
$h_Lapp_data_OrganizationName$package$OrganizationNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aDq;
});
$p.eO = (function() {
  return this.aDH;
});
$p.bW = (function() {
  if ((!this.aDu)) {
    this.aDt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aDu = true;
  }
  return this.aDt;
});
$p.b9 = (function() {
  if ((!this.aDy)) {
    this.aDx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aDy = true;
  }
  return this.aDx;
});
$p.b3 = (function() {
  if ((!this.aDG)) {
    this.aDF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aDG = true;
  }
  return this.aDF;
});
$p.aG = (function() {
  if ((!this.aDs)) {
    this.aDr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aDs = true;
  }
  return this.aDr;
});
$p.az = (function() {
  if ((!this.aDE)) {
    this.aDD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aDE = true;
  }
  return this.aDD;
});
$p.aY = (function() {
  if ((!this.aDA)) {
    this.aDz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aDA = true;
  }
  return this.aDz;
});
$p.ata = (function() {
  if ((!this.aDC)) {
    this.aDB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Organization Name";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aDC = true;
  }
  return this.aDB;
});
$p.bNE = (function() {
  if ((!this.aDw)) {
    this.aDv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aDw = true;
  }
  return this.aDv;
});
var $d_Lapp_data_OrganizationName$package$OrganizationNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationName$package$OrganizationNameForm$, "app.data.OrganizationName$package$OrganizationNameForm$", ({
  Et: 1,
  N: 1
}));
export { $d_Lapp_data_OrganizationName$package$OrganizationNameForm$ as $d_Lapp_data_OrganizationName$package$OrganizationNameForm$ };
var $n_Lapp_data_OrganizationName$package$OrganizationNameForm$;
function $m_Lapp_data_OrganizationName$package$OrganizationNameForm$() {
  if ((!$n_Lapp_data_OrganizationName$package$OrganizationNameForm$)) {
    $n_Lapp_data_OrganizationName$package$OrganizationNameForm$ = new $c_Lapp_data_OrganizationName$package$OrganizationNameForm$();
  }
  return $n_Lapp_data_OrganizationName$package$OrganizationNameForm$;
}
export { $m_Lapp_data_OrganizationName$package$OrganizationNameForm$ as $m_Lapp_data_OrganizationName$package$OrganizationNameForm$ };
//# sourceMappingURL=app.data.-Organization-Name$package$-Organization-Name-Form$.js.map
